var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "audioDialog",
      attrs: { visible: _vm.dialogaudioVisible, "append-to-body": "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogaudioVisible = $event
        },
        close: _vm.closeView,
      },
    },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { height: "350px" },
          attrs: { "tab-position": _vm.tabPosition },
          on: { "tab-click": _vm.handleTabsClick },
          model: {
            value: _vm.activeTabsValue,
            callback: function ($$v) {
              _vm.activeTabsValue = $$v
            },
            expression: "activeTabsValue",
          },
        },
        _vm._l(_vm.audioData, function (audioItem, audioIndex) {
          return _c(
            "el-tab-pane",
            {
              key: audioIndex,
              attrs: {
                name: audioItem.name,
                stretch: true,
                label:
                  audioItem.name.length > 12
                    ? audioItem.name.substring(0, 12) + "..."
                    : audioItem.name,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: audioItem.name,
                                    placement: "top",
                                    effect: "light",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        width: "95%",
                                        margin: "0 auto",
                                        "text-align": "center",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            audioItem.name +
                                              "." +
                                              audioItem.path.substring(
                                                audioItem.path.lastIndexOf(
                                                  "."
                                                ) + 1
                                              )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.judgeFileType(audioItem.path)
                                ? _c(
                                    "audio",
                                    {
                                      ref: "myAudio",
                                      refInFor: true,
                                      staticStyle: {
                                        width: "95%",
                                        height: "170px",
                                      },
                                      attrs: {
                                        src: _vm.ossPath + audioItem.path,
                                        controls: "controls",
                                      },
                                    },
                                    [_vm._v(" 您的浏览器不支持 audio 标签。 ")]
                                  )
                                : _c("img", {
                                    staticStyle: {
                                      width: "160px",
                                      height: "160px",
                                      cursor: "pointer",
                                    },
                                    attrs: {
                                      src: require("@/icon/yinpin.svg"),
                                      fit: _vm.fit,
                                      title: audioItem.name,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDownload(audioItem)
                                      },
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }